import Resource from "../../shared/actions/resourceActions";

export class ProjectsCatalogResource extends Resource {
  constructor(dispatch, projectId) {
    super(dispatch, "project", `/api/v1/projects/${projectId}/catalogs`);
  }
}
